import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";

import { isTaskCompleted } from "../helpers";
import { OrganizationGamificationTask } from "../schema";
import WeeklyConsistencyChallenge from "./WeeklyConsistencyChallenge";

interface Props {
  numOfCardsToRender: number | null;
}

const ExperiencePro = ({ numOfCardsToRender }: Props) => {
  const { gamificationProfile } = useContext(OrganizationUserContext);

  return (
    <>
      <WeeklyConsistencyChallenge
        completed={isTaskCompleted(
          gamificationProfile,
          OrganizationGamificationTask.email_streak,
          1,
        )}
      />
    </>
  );
};

export default ExperiencePro;
